import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getDealTypeTitleByType } from '../../service/DealsHelpers/DealsHelpers';
import { DealType } from '../../typings/graphql-grid';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

type DealCellTypeProps = {
    type: DealType;
};

export class DealCellType extends React.PureComponent<DealCellTypeProps> {
    render() {
        const { type } = this.props;
        const iconType = this.getIconNameForDealsType(type);

        return iconType ? (
            <Shape2
                cls={Bem.cls('grid-type-cell', 'icon')}
                icon={iconType}
                width={16}
                height={16}
                theme={Shape2Theme.light}
                title={getDealTypeTitleByType(type)}
            />
        ) : null;
    }

    private getIconNameForDealsType = (type: DealType): Shape2Icon | null => {
        switch (type) {
            case 'PREFERRED_DEAL':
                return Shape2Icon.preferredDeal;

            case 'PRIVATE_MARKETPLACE':
                return Shape2Icon.privateMarketplace;

            default:
                return null;
        }
    };
}
